import _default from './Feed';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/views/Feed/index.js
// module id = 998
// module chunks = 0